export default "__VITE_ASSET__ec53cee3__"